import {reportIpmAction, type IpmMetricTags} from '@github-ui/ipm-telemetry'
import {InfoIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useMemo} from 'react'
import {IpmBannerBase} from '../ipm-banner-base/IpmBannerBase'

export interface TbbSetupBudgetBannerProps {
  entityName: string
  ctaHref: string
  dismissPath: string
  analytics: TbbSetupBudgetBannerAnalytics
  rounded?: boolean
}

export interface TbbSetupBudgetBannerAnalytics {
  visibleEvent: string
  dismissEvent: string
  clickEvent: string
  location: string
}

export function TbbSetupBudgetBanner({
  entityName,
  ctaHref,
  dismissPath,
  analytics,
  rounded,
}: TbbSetupBudgetBannerProps) {
  const isGlobal = (rounded ?? true) === false || analytics.location === 'global'
  const telemetryTags = useMemo<IpmMetricTags>(
    () => ({
      package: 'in-product-targeting',
      component: 'TbbSetupBudgetBanner',
      display_location: analytics.location,
      category: 'tbb_setup_budget_banner',
      nudge_id: 'tbb_setup_budget_banner',
      variant: 'default',
    }),
    [analytics.location],
  )

  return (
    <IpmBannerBase
      dismissPath={dismissPath}
      visibleEvent={analytics.visibleEvent}
      dismissEvent={analytics.dismissEvent}
      testId="tbb-setup-budget-banner"
      title="Copilot budget setup"
      icon={<InfoIcon />}
      location={analytics.location}
      rounded={rounded}
      telemetryTags={telemetryTags}
      description={
        <span className="text-normal">
          GitHub Copilot billing for <strong>{entityName}</strong> is now usage-based. Set a per-user budget to manage
          costs.
        </span>
      }
      primaryAction={
        <Button
          as="a"
          href={ctaHref}
          size={isGlobal ? 'small' : 'medium'}
          data-analytics-event={analytics.clickEvent}
          onClick={() => reportIpmAction('cta_click', telemetryTags)}
        >
          Set your budget
        </Button>
      }
    />
  )
}
